import { http } from 'services'

const state = () => ({
  validation: {},
  errors: null,
})

// getters
const getters = {
}

// actions
const actions = {
  ['validateInput.validate'] ({ commit }, params) {
    commit('CLEAR_ERRORS');
    return http
      .post('validate-reservation-input', params)
      .then((res) => {
        commit('VALIDATE', res);
        return { ok: true, data: res && res.data };
      })
      .catch((err) => {
        if (err && err.response) {
          commit('ERROR', err);
        }
        return { ok: false, response: err && err.response };
      });
  }
}

// mutations
const mutations = {
  VALIDATE (state, res) {
    state.validation = Object.assign({}, res.data);
  },

  //ERRORS
  ERROR (state, err) {
    state.errors = err.response;
  },

  CLEAR_ERRORS (state) {
    state.errors = null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
